import { useMemo } from "react";
import { RequestStatus } from "@interfaces";

function normalizeStatus(status: RequestStatus | undefined) {
  const fallbackStatus = RequestStatus.DRAFT;

  return status ?? fallbackStatus;
}

export function isRequestInmutable(status: RequestStatus | undefined) {
  if (!status) return false;

  return [RequestStatus.ACCEPTED, RequestStatus.REJECTED].includes(status);
}

export function useRequestSigningStatus(status: RequestStatus | undefined) {
  const normalizedStatus = useMemo(() => normalizeStatus(status), [status]);

  const isSigning = normalizedStatus === RequestStatus.SIGNING;
  const isSigningError = normalizedStatus === RequestStatus.SIGNING_ERROR;

  return {
    normalizedStatus,
    isSigning,
    isSigningError,
    isSigningOrError: isSigning || isSigningError,
    isInmutable:
      status && [RequestStatus.ACCEPTED, RequestStatus.REJECTED].includes(status),
    isModifiable: status && [RequestStatus.DRAFT, RequestStatus.PENDING].includes(status),
  };
}
